import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../shared/store';
import { useHttpClient } from '../../../shared/http-client';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import { CustomerForm } from './customers-form';
import { VisitasTab } from './tabs/visitas-tab';




export const CustomersEdit = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { get, set } = useStore();
    const { api, state } = useHttpClient();
    const { id } = useParams();
    const [data, setData] = useState<any | null>(null);
    const [tabIndexMaster, setTabIndexMaster] = useState(+get('customers-tab-index') || 0);
    const [isTab, setIsTab] = useState(false);

    useEffect(() => {
        if (id) {
            api(`/fleet/customers/${id}/`, 'GET');
        }
    }, [id]);

    const handleChangeValues = () => {
        setIsTab(true);
    };

    useEffect(() => {
        if (state.data) {
            if (state.path.includes('customers')) {
                setData(state.data);
                /*  if (!isTab) {
                     setTabIndexMaster(0);
                 } */

            }
        }

        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div className='py-4 px-8'>
            <div
                className="pb-4 cursor-pointer"
                onClick={() => {
                    navigate(-1);
                    setTabIndexMaster(0);
                    set('customers-tab-index', 0);
                }}
            >
                <span className='text-black pt-[5px]'>{'< '}</span>
                <span className='text-black text-[12px]'>{t('common.button.back')}</span>
            </div>
            <div className='flex'>
                <div className="text-2xl  text-gray-900 pb-4 pr-2">
                    {t('common.form-label.cliente')}
                </div>
            </div>

            <Tabs
                selectedIndex={tabIndexMaster}
                onSelect={(index) => {
                    setTabIndexMaster(index);
                    set('customers-tab-index', index);
                }}>
                <TabList>
                    <Tab style={{ fontWeight: tabIndexMaster === 0 ? 'bold' : 'normal' }} >
                        <div className='flex'>
                            {t('common.label.general')}{/* <ExclamationCircleIcon className="h-6 w-6 text-red-600 rounded-full ml-2" /> */}
                        </div>
                    </Tab>
                   <Tab style={{
                        fontWeight: tabIndexMaster === 1 ? 'bold' : 'normal'
                    }} >{t('common.label.visitas')}</Tab> 
                    
                </TabList>

                <TabPanel>
                    <CustomerForm item={data} close={() => navigate(-1)} onAction={handleChangeValues} isEdit={true} />
                </TabPanel>
                <TabPanel>
                    <VisitasTab item={id} onAction={handleChangeValues} />
                </TabPanel> 
                
            </Tabs>

        </div>
    );
};